import { Actions, Header, Link, Text } from '@gasbuddy/react-components';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { Fragment, useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { noop } from '../../../lib/utils';
import sortFavoriteLists from '../../../lib/utils/sortFavoriteLists';
import { FavoriteListPropType } from '../../prop-types/favoriteList';
import FavoriteListsDropdown from '../FavoriteListsDropdown';
import styles from './FavoriteStationIcon.module.css';

const cx = classNames.bind(styles);

export default function AddStationToFavorites({
  error,
  favoriteLists,
  onAddStationToFavorites,
  onCancel,
}) {
  const { t } = useTranslation(['favorites', 'miscellaneous']);
  const [favoriteListId, setFavoriteListId] = useState(() => {
    const sortedLists = sortFavoriteLists(favoriteLists);
    return sortedLists.length && sortedLists[0].id;
  });

  const handleAddStationToFavorites = useCallback(() => {
    onAddStationToFavorites(favoriteListId);
  }, [favoriteListId, onAddStationToFavorites]);

  const handleFavoriteListChange = useCallback((list) => {
    if (list) {
      setFavoriteListId(list.id);
    }
  }, []);

  return (
    <Fragment>
      <Header as="h3">{t('chooseListToAdd')}</Header>
      <FavoriteListsDropdown
        className={cx('favoriteListsDropdown')}
        value={favoriteListId}
        favoriteLists={favoriteLists}
        onChange={handleFavoriteListChange}
      />
      {!!error && (
        <Text as="p" color="orange">
          {error}
        </Text>
      )}
      <br />
      <Actions>
        <Actions.Button
          primary
          fluid
          onClick={handleAddStationToFavorites}
          disabled={!favoriteListId}
          desktop={6}
        >
          {t('addToList')}
        </Actions.Button>
        <Actions.Action>
          <Link uppercase onClick={onCancel}>
            {t('actions.cancel', { ns: 'miscellaneous' })}
          </Link>
        </Actions.Action>
      </Actions>
    </Fragment>
  );
}

AddStationToFavorites.propTypes = {
  error: PropTypes.string,
  favoriteLists: PropTypes.arrayOf(FavoriteListPropType),
  onAddStationToFavorites: PropTypes.func,
  onCancel: PropTypes.func,
};

AddStationToFavorites.defaultProps = {
  error: undefined,
  favoriteLists: [],
  onAddStationToFavorites: noop,
  onCancel: noop,
};
